<template>
    <div class="dl">
      <meta-info>
        <title>Dedicated Lines - inte-QT</title>
        <meta name="title" content="Dedicated Lines - inte-QT" />
        <meta
          name="description"
          content="A dedicated line is a fibre/copper/radio connection between two points, one point is the end user location. It is symmetrical, so will have fast, equal upload and download speeds."
        />
        <link rel="canonical" href="https://www.inte-qt.com/services/dedicated-lines" />
      </meta-info>
  
      <img
        src="@/assets/images/3cGzLfl.jpg"
        alt="Dedicated Lines Banner"
        class="banner-img banner-img__black"
      />
      <h1 class="text-center banner-img__header">Dedicated Lines</h1>
  
      <div class="container-fluid">
        <div class="container" align="justify">
          <div class="b_read">
            <p class="dl__subtitle text-center">
              High Bandwidth point to point connectivity with unmatched global
              presence, best suitable for Enterprises, Carriers and Integrators.
            </p>
  
            <h3 class="dl__q">
              What is Dedicated Line (DIA) and its Importance in business growth?
            </h3>
            <p>
              A dedicated line is a fibre/copper/radio connection between two
              points, one point is the end user location. It is symmetrical, so
              will have fast, equal upload and download speeds.
            </p>
            <p>
              It's an uninterrupted connection with dedicated speed, ultra-low
              latency, direct to businesses — just like a pipe that can carry many
              things, a leased line can be used to carry a variety of data
              traffic, VPN traffic over WAN or LAN, phone calls; and VoIP.
            </p>
  
            <h3 class="dl__q">
              Global coverage across Tier 1, Tier 2, Tier 3 cities and far-flung areas:
            </h3>
            <p>
              We have relations with carriers and managed services partners in more
              than <strong>190+ countries</strong> across the world, which gives us unmatched
              presence to provide dedicated internet access (DIA) in remote areas
              with multiple bandwidth capabilities and stringent SLAs.
            </p>
  
            <h3 class="dl__q">Network that is dedicated solely to your needs:</h3>
            <ol>
              <li>
                <p>
                  Packages up to <strong>10Gb</strong>, all with totally uncontended Bandwidth.
                </p>
              </li>
              <li>
                <p>Static IP on WAN and LAN side, as per customer’s needs.</p>
              </li>
              <li>
                <p>
                  Dedicated Customer premise equipment (CPE) covering hardware guarantee.
                </p>
              </li>
              <li>
                <p>Tested guaranteed bandwidth, low latency, and minimal packet loss.</p>
              </li>
              <li>
                <p>
                  Dedicated <strong>24*7*365</strong> customer support with proactive monitoring by
                  our NSOC team.
                </p>
              </li>
            </ol>
  
            <h3 class="dl__q">What makes inte-QT unique?</h3>
            <ol>
              <li>
                <p>Unmatched Global presence with Local expertise.</p>
              </li>
              <li>
                <p>Tailor-made solutions with fully flexible contracts and terms.</p>
              </li>
              <li>
                <p>Low delivery lead times.</p>
              </li>
              <li>
                <p>
                  Dedicated NSOC team support with proactive monitoring
                  <strong>24*7*365</strong>.
                </p>
              </li>
            </ol>
          </div>
        </div>
      </div>
  
      <div class="dl__space">
        <ConnectivitySolutions />
      </div>
  
      <div class="my-5 g-5">
        <h2 class="mt-5 text-center center-header mx-auto">
          We help not one, but many companies.
        </h2>
        <CarouselIndu />
      </div>
  
      <TestimonialCarousel />
      <GetInTouch />
    </div>
  </template>
  
  <script setup>
  import { onMounted } from 'vue';
  import { useHead } from '@vueuse/head';
  
  import CarouselIndu from '@/components/CarouselIndu.vue';
  import ConnectivitySolutions from '@/components/ConnectivitySolutions.vue';
  import GetInTouch from '@/components/GetInTouch.vue';
  import TestimonialCarousel from '@/components/TestimonialCarousel.vue';
  
  onMounted(() => {
    window.scrollTo(0, 0);
  });
  
  useHead({
    title: 'Dedicated Lines - inte-QT',
    meta: [
      {
        name: 'description',
        content:
          'A dedicated line is a fibre/copper/radio connection between two points, one point is the end user location. It is symmetrical, so will have fast, equal upload and download speeds.',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.inte-qt.com/services/dedicated-lines',
      },
    ],
  });
  </script>
  
  <style scoped>
  </style>
  